import { Component, OnInit, ElementRef, AfterContentInit, AfterViewInit, OnChanges, DoCheck, Inject, OnDestroy  } from '@angular/core';
import { DwComponent, DwComponentType, DwContainerOptions, DwSecurityUserService, DwSectionBaseComponent, DwMetaDataGridActionState,
         DwDateTimeInputOptions, DwOrmDataServiceToken, DwOrmDataService, DwMetaDataFormStateService, DwGridEvents,
         DwMetaDataFormApi, DwEventService, DwMdEventService, DwGridEvent, DwEvent, DwMdLoadEventData, DwGridDeleteActionService,
         DwMdQueryEventData, DwMetaDataFilters, DwMetaDataFilter, DwActionPreference, DwMetaDataGridApi, DwMetaDataService, DwMetaDataServiceToken,
         DwFormActionConfig, DwFormActionInterceptResult, DwInMemoryDataSource, DwFormContextMode, DwMetaDataGridPreferences, DwGridActionResult } 
         from '@devwareapps/devware-cap';
import { DwGridRefreshEventData } from '@devwareapps/devware-cap/devware-ui-metadata/grid/model/events/dw-grid-refresh-event-data.model.d';
import { FleetMetaDataItemNames, FleetMetaDataLookups, MaintenanceEntity, ServiceTypeEntity, FleetVehicleEntity } 
         from '../meta-data/fleet-meta-data.service';
import { AppPermissions } from 'src/app/meta-data/app-permissions.enum';
import { Observable, Subscription, of } from 'rxjs';
import * as moment_ from 'moment';
const moment = moment_;

@DwComponent(
  {
    key: 'vehicle-maintenance-link',
    name: 'Link to Maintenance',
    componentType: DwComponentType.pageComponent,
    isGlobal: true,
  }
)
@Component({
  selector: 'vehicle-maintenance-link',
  template: `<a href="#" style="font-size: 0.825rem" target="_blank" [routerLink]="['/fleet/vehicle-maintenance']" [queryParams]="{ UnitId: uid }" >'{{uid}}' Maintenance Log</a> `
})
export class AddMaintenanceLinkComponent {
    uid: string = '';    
    formApi : DwMetaDataFormApi;
    vehicle : FleetVehicleEntity;

    constructor(private dwSecurityUserService: DwSecurityUserService,
            private dwGridDeleteActionService : DwGridDeleteActionService,
            @Inject(DwMetaDataServiceToken) private dwMetaDataService : DwMetaDataService,
            @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
            private dwEventService: DwEventService,
            private dwFormStateService: DwMetaDataFormStateService) 
    {
        this.formApi = dwFormStateService.state.formApi;
        this.vehicle = this.formApi.getFormData(); 
        this.uid = this.vehicle.UnitId;
    }
}
